import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "./CustomButton";
import uploadIcon from "../assets/upload_icon.png";
import deleteIcon from "../assets/circled_cancel.svg";
import { DoneIcon, WarningIcon } from "../assets/registtyIcons/icons";
import classes3 from "./PDFUploader.module.css";
import ErrorBox from "./ErrorBox";

const UploadFiles = ({
                       fieldName,
                       file,
                       onFileChange,
                       onDeleteFile,
                       disabled,
                     }) => {
  const fileInputRef = useRef(null);
  const { t } = useTranslation("general");
  const [error, setError] = useState("");

  const MAX_FILE_SIZE_MB = 5;
  const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

  const allowedTypes = [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const handleButtonClick = () => {
    if (disabled) return;
    fileInputRef.current?.click();
  };

  const handleInputChange = (e) => {
    const selectedFile = e.target.files?.[0];

    if (!selectedFile) return;

    setError("");

    // فحص الحجم
    if (selectedFile.size > MAX_FILE_SIZE_BYTES) {
      setError(t("fileSizeTooLarge"));
      e.target.value = "";
      return;
    }

    // فحص النوع
    if (!allowedTypes.includes(selectedFile.type)) {
      setError(t("unsupportedFileType"));
      e.target.value = "";
      return;
    }

    onFileChange(selectedFile, fieldName);
  };

  const handleDelete = () => {
    setError("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    onDeleteFile(fieldName);
  };

  return (
      <div className="o-column o-column--gap-size_100 u-padding_0">
        <div className="u-width--max-width_300">
          <input
              ref={fileInputRef}
              type="file"
              id={fieldName}
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              onChange={handleInputChange}
              className={`${classes3.fileInput} u-padding_0`}
              style={{ display: "none" }}
          />

          <div className="u-margin--top_300">
            {!file && (
                <CustomButton
                    flex
                    title={t("uploadDocument")}
                    icon={uploadIcon}
                    onClick={handleButtonClick}
                    iconSize={18}
                    disabled={disabled || file}
                />
            )}
          </div>

          <div className="u-width--max-width_300 o-row o-row--vertical-align_center u-margin--top_300">
            <div className="o-row o-row--vertical-align_center">
              {file ? (
                  <span>
                <DoneIcon width={30} height={30} />
              </span>
              ) : (
                  <span className="u-color_success u-font-size_small o-row o-row--vertical-align_center o-row--gap-size_200">
                <WarningIcon width={20} height={20} />
                    {t("noFileSelected")}
              </span>
              )}
            </div>

            {file && (
                <div className={classes3.fileName}>
                  {t("file")}
                  <button
                      type="button"
                      className={classes3.deleteFileButton}
                      onClick={handleDelete}
                  >
                    <img
                        src={deleteIcon}
                        className="u-height-specific_20"
                        alt="Delete"
                    />
                  </button>
                </div>
            )}
          </div>

          {error && (
              <div className="u-margin--top_200">
                <ErrorBox>{error}</ErrorBox>
              </div>
          )}
        </div>
      </div>
  );
};

export default UploadFiles;